export default __webpack_public_path__ + "static/media/icon-bookmark-green.5793b0dd.svg";